import React from "react";
import Logo from "../assets/Int2criuses_logo.svg" ;
import { Link } from "react-router-dom";
// import facebook from "../assets/Vector.png" ;
// import instagram from "../assets/Vector-1.png" ;
// import linkedin from "../assets/Vector-2.png" ;
// import youtube from "../assets/Vector-3.png" ;
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faFacebook, faInstagram,  faYoutube} from '@fortawesome/free-brands-svg-icons';
import { faLinkedin } from "@fortawesome/free-brands-svg-icons/faLinkedin";




const Footer = () => {
    return(
        <>

        <div className="footer">

        <div className="footer-mainrow">

        <div className="col1">
       <a href="https://www.int2cruises.com" target="_self" > <img src={Logo} alt="Int2Cruise " /></a>
        <p>All things cruising, all on one platform. With 50+ years of collective experience, we make sure cruise planning is smooth sailing. Whether your are looking for a quick getaway, or an elaborate holiday - let’s get int2 it!</p>

        </div>

        <div className="col2">
        <ul>
            <li><Link to="/about">About Us</Link></li>
            {/* <li><Link to="/about">Blog</li> */}
            <li><Link to="/contact">Contact Us</Link></li>
            <li><Link to="/blog">Blog</Link></li>
        </ul>
        </div>

        <div className="col3">
        <ul>
            <li><Link to="/cruisedeals">Cruise Deals</Link></li>
            <li><Link to="/privacy-policy">Privacy Policy</Link></li>
        </ul>

        </div>
    

       <div className="col4">
       {/* <h3>JOIN OUR NEWSLETTER</h3>
       <p>Be the first to get all updates straight to your inbox</p>
       <input type="text" placeholder="Enter email address"></input><br></br>
       <button>Subscribe</button> */}

         <div className="socials">
        <h5>Int2Cruises Singapore</h5>
        <div>
        <a href="https://www.facebook.com/TheJustCruiseCompany" target="_blank" rel="noreferrer" ><FontAwesomeIcon icon={faFacebook} style={{color:'#164d55',height:'35px',width:'35px'}}/></a>
        <a href="https://www.instagram.com/int2cruises/" target="_blank" rel="noreferrer" ><FontAwesomeIcon icon={faInstagram} style={{color:'#164d55',height:'35px',width:'35px'}}/></a>

        </div>
       </div>

       <div className="socials">
        <h5>Int2Cruises India</h5>
        <div>
            <a href="https://www.facebook.com/Int2CruisesIndia/"  target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faFacebook} style={{color:'#164d55',height:'35px',width:'35px'}}/></a>
            <a href="https://www.instagram.com/int2cruises_india/" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faInstagram} style={{color:'#164d55',height:'35px',width:'35px'}}/></a>
            <a href="https://www.linkedin.com/company/int2cruises" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faLinkedin} style={{color:'#164d55',height:'35px',width:'35px'}}/></a>
            <a href="https://www.youtube.com/@Int2Cruises" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faYoutube} style={{color:'#164d55',height:'35px',width:'35px'}}/></a>
        
        </div>
       </div>


       </div>


       </div>

       <p style={{textAlign:'center'}} className="copyright-section">Copyright © 2025 Interzign Travel and Technology Pte. Ltd. <br></br>All Rights Reserved</p>

        </div>





        </>
    );
}

export default Footer ;